module.exports = __webpack_public_path__ + "img/platform-channel-32.76d9c88a.svg";